<template>
   <!-- 服务设置 serviceSettings -->
  <div class="advanced-form priceset">
    <a-form :form="form">

      <div class="card">
        <div class="card-body">
          <a-form-item
            label="代取快递服务费(单次)"
            v-bind="$store.state.base_itemLayout">
            <a-input v-decorator="['takePackageOneFee', monney]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item
            label="代扔垃圾服务费(单次)"
            v-bind="$store.state.base_itemLayout">
            <a-input v-decorator="['throwGarbageOneFee', monney]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item
            label="代扔垃圾包月服务费"
            v-bind="$store.state.base_itemLayout">
            <a-input v-decorator="['throwGarbageMonthFee', monney]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item
            label="代扔垃圾包季服务费"
            v-bind="$store.state.base_itemLayout">
            <a-input v-decorator="['throwGarbageQuarterFee', monney]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item
            label="代扔垃圾包年服务费"
            v-bind="$store.state.base_itemLayout">
            <a-input v-decorator="['throwGarbageYearFee', monney]" placeholder="请输入"/>
          </a-form-item>

          <a-form-item
            label="服务订单佣金比例设置"
            v-bind="$store.state.base_itemLayout">
            <a-input v-decorator="['orderCommissionPoint', ratio]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item
            label="管家卖货佣金比例设置（所在服务小区佣金比例）"
            v-bind="$store.state.base_itemLayout">
            <a-input v-decorator="['sellLimitCommissionPoint', ratio]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item
            label="管家卖货佣金比例设置（不限小区售卖佣金比例）"
            v-bind="$store.state.base_itemLayout">
            <a-input v-decorator="['sellCommissionPoint', ratio]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item
            label="管家团购/活动积分返还比例"
            v-bind="$store.state.base_itemLayout">
            <a-input v-decorator="['activityReturnPoint', ratio]" placeholder="请输入"/>
          </a-form-item>

          <a-form-item :wrapper-col="{ span: 8, offset: 8}">
            <a-button
              :style="{marginRight: '10px'}"
              v-for="(item, index) of toolBarList"
              :key="index"
              @click="item.handle(item)"
              :type="item.type"
              :disabled="item.authDisabled"
              :loading="item.loading && btnLoading.loading"
              size="large"
              v-hasPermi="item.permi"
            >
              {{item.text}}
            </a-button>
          </a-form-item>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'priceSet',
  data () {
    let priceReg = /^\d+(\.\d{0,2})?$/;
    // let priceReg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;

    return {
      btnLoading: {
        loading: false
      },
      monney: {
        initialValue: '0',
        rules: [{required: true, message: '请输入'}, {pattern: /^(([1-9]([0-9]{1,3})?(\.[0-9]{1,2})?)|([0]\.[1-9]|0\.0[1-9]|0\.[1-9][0-9])||10000)$/, message: '请输入0.01~10000的数字'}]
      },
      ratio: {
        initialValue: '0',
        rules: [{required: true, message: '请输入'}, {pattern: /^(([1-9]([0-9]{1,1})?(\.[0-9]{1,2})?)|([0]\.[1-9]|0\.0[1-9]|0\.[1-9][0-9])||100||0)$/, message: '请输入0~100的数字'}]
      },

      toolBarList: [
        {text: '保存', handle: this.handleSubmit, type: 'primary', loading: true, key: 'confirm', permi: "['community:housekeepSettings:save']"}
        // {text: '取消', handle: () => this.form.resetFields(), type: 'plain', key: 'cancel'}
      ]
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    this.getDetail();
  },
  methods: {
    getDetail () {
      this.$get({
        url: '/housekeep/settings/getInfo',
        params: {
          unique: 'service_settings_price'
        }
      }).then(({data}) => {
        let formData = {
          takePackageOneFee: undefined,
          throwGarbageOneFee: undefined,
          throwGarbageMonthFee: undefined,
          throwGarbageQuarterFee: undefined,
          throwGarbageYearFee: undefined,
          orderCommissionPoint: undefined,
          sellLimitCommissionPoint: undefined,
          sellCommissionPoint: undefined,
          activityReturnPoint: undefined
        };
        Object.keys(formData).forEach((el) => {
          if (data.hasOwnProperty(el)) {
            formData[el] = data[el];
          }
        });
        this.form.setFieldsValue(formData);
      });
    },
    /** 提交表单 */
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        this.$post({
          url: '/housekeep/settings/save',
          params: values
        }).then(({data}) => {
          this.$message.success('设置成功');
          this.getDetail();
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .priceset {
    .ant-input {
      width: 70%;
    }
    .ant-form-text {
      margin-left: 8px;
      min-width: 70px;
    }
  }
</style>
